import { defineModel } from "../define-model";

export type CalendarSlot = { weekday: number; time: string };

export type Calendar = {
	id: string;
	workspaceId: string;
	projectId: string;
	timezone: string;
	zernioProfileId: string | null;
	settings: { slots?: CalendarSlot[]; defaultAccountIds?: string[] };
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		calendar: Calendar;
	}
}

export const model = defineModel({ name: "calendar", load: "eager", indexes: ["projectId"] });
